import NextImage, {ImageProps} from 'next/image'
import React from 'react'
import {ExternalType, parseExternalLink} from '@/src/shared/utils/links'

export interface ImageComponentProps extends Omit<ImageProps, 'alt'> {
  alt?: string
  ref?: (element: any) => void
}

export const Image = (props: ImageComponentProps) => {
  const src = parseExternalLink(ExternalType.Image, props.src)

  return <NextImage {...props} src={src} alt={props.alt ?? src} />
}
